/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {BetWinMode} from "../core/config/BetWinMode";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {StackedSymbol} from "../core/reel/stackedsymbol/StackedSymbol";
import {RockBottomSound} from "./sound/RockBottomSound";
import {IBetWayWinData} from "./server/data/IRockBottomData";


export class RockBottomGameConfig {
    //xBet
    public static IS_BOOSTED_BET: boolean = false;

    //anticipation fade time
    public static FADE_DUR_ANTICIPATION: number = 0.3;

    // Game basic
    public static BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;

    // spins counter init scale
    public static SPINS_COUNT_SCALE: number = 0.8;

    // Reels
    public static REELS_NUM: number = 5;
    public static MID_SYMS: string[] = ["M1", "M2", "M3", "M4", "M5"];
    public static LOW_SYMS: string[] = ["L1", "L2", "L3", "L4", "L5"];
    public static SYMS_PER_REEL: number[] = [3, 4, 4, 4, 3];

    // Symbols
    public static SYMBOL_WIDTH: number = 144;
    public static SYMBOL_HEIGHT: number = 148;
    public static SYMBOL_BOTTOM_PADDING: number = 0;

    //for soft win cap
    public static BET_WAY_WIN_DATA: IBetWayWinData[] = [];
    public static EVALUATED_AREA: string[][] = [];

    //lucky draw
    public static IS_LUCKY_DRAW: boolean = false;

    // Win
    public static REEL_WIN_POSITIONS: boolean[][] =
        [[false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false, false],
            [false, false, false]]; // according to SYMS_PER_REEL

    public static WIN_RATIOS: IWinRatioConfig[] = [
        {
            ratio: 0,
            name: "Tiny Win",
            duration: 0,
            bigWinLevel: -1,
            soundName: RockBottomSound.WIN_TINY_SOUND,
            endSoundName: ""
        },
        {
            ratio: 1.5,
            name: "Small Win",
            duration: 0,
            bigWinLevel: -1,
            soundName: RockBottomSound.WIN_SMALL_SOUND,
            endSoundName: ""
        },
        {
            ratio: 3,
            name: "Medium Win",
            duration: 0.4,
            bigWinLevel: -1,
            soundName: RockBottomSound.WIN_MEDIUM_COUNTUP,
            endSoundName: RockBottomSound.WIN_MEDIUM_ENDING
        },
        {
            ratio: 5,
            name: "Large Win",
            duration: 0.8,
            bigWinLevel: -1,
            soundName: RockBottomSound.WIN_LARGE_COUNTUP,
            endSoundName: RockBottomSound.WIN_LARGE_ENDING
        },
        {
            ratio: 15,
            name: "Big Win 1",
            duration: 4.8,
            bigWinLevel: 0,
            soundName: "",
            endSoundName: ""
        },
        {
            ratio: 25,
            name: "Big Win 2",
            duration: 4.8,
            bigWinLevel: 1,
            soundName: "",
            endSoundName: ""

        },
        {
            ratio: 50,
            name: "Big Win 3",
            duration: 4.8,
            bigWinLevel: 2,
            soundName: "",
            endSoundName: ""
        },
        {
            ratio: 100,
            name: "Big Win 4",
            duration: 4.8,
            bigWinLevel: 3,
            soundName: "",
            endSoundName: ""
        },
        {
            ratio: 250,
            name: "Big Win 5",
            duration: 4.8,
            bigWinLevel: 4,
            soundName: "",
            endSoundName: ""
        }
    ];

    public static REEL_SETS: IReelSets = {
        "NORMAL_REELSET": [
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L2", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L5", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "M2", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L1", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L5", "L4", "M5"]
        ],
        "FREESPIN_REELSET": [
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"]
        ],
        "SUPER_FREESPIN_REELSET": [
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"],
            ["M1", "M1", "M3", "M2", "M2", "M4", "M5", "M3", "X", "M4", "M5"]
        ],
        "WINCAP_PICK_REELSET": [
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L2", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L5", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "M2", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L1", "L4", "M5"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L5", "M3", "L5", "L4", "M5"]
        ]
    };

    public static getReelSetName(mode: string): string {
        return `${mode}_REELSET`;
    }

    public static updateReelSets(): void {
        // Filter stacked symbols on REEL_SETS if any.
        for (let reelSetKey in this.REEL_SETS) {
            this.REEL_SETS[reelSetKey].forEach((reelSet: string[], reelId: number) => {
                this.REEL_SETS[reelSetKey][reelId] = StackedSymbol.filterStackedSymbolsReelSet(reelSet, reelId);
            });
        }
    }

    public static resetVariablesForWinCap(): void {
        RockBottomGameConfig.BET_WAY_WIN_DATA = [];
        RockBottomGameConfig.EVALUATED_AREA = [];
    }
}